import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams} from "react-router-dom";
import Collapsible from "react-collapsible";
import ProfileItems from "./serviceItems"
import { IoIosAddCircle } from "react-icons/io";
import AddItemTypeModal from "./addItemTypeModal";

function ServiceAndMaintainance(props) {
    let { id } = useParams();
    const fleetId = id
    const { advancedVehicleList } = useSelector(
      (state) => state?.fleet
    );
    let serviceItems = useSelector((state) => state?.fleet?.serviceItems);
    console.log("serviceItemsserviceItemsserviceItems",serviceItems);
    
    const vehicle = advancedVehicleList?.filter(
      (element) => element.fleetId == fleetId
    )[0];
    console.log("vehicle", vehicle, fleetId);
    const vehicleServiceData = useSelector((state) => state?.fleet?.vehicleProfileData?.serviceData);
    console.log("vehicleServiceData11",vehicleServiceData);
    const [isOpenWearable, setIsOpenWearable] = useState(true);
    const [isOpenLubrication, setIsOpenLubrication] = useState(false);
    const [openAddExpanse, setOpenAddExpanse] = useState(false);
    const closeAddExpense = () => {
        setOpenAddExpanse(false);
    };
    const toggleAddExpense = () => {
        setOpenAddExpanse(!openAddExpanse);
    }

    
  const serviceList = [
    {
      key: "Wearables",
      open: () => {
        console.log("setIsOpenWearable",isOpenWearable );
        setIsOpenWearable(!isOpenWearable)
      },
      close: () => {
        console.log("setIsOpenWearable",isOpenWearable );
        setIsOpenWearable(!isOpenWearable)
      },
      isOpen: isOpenWearable,

    },
    {
      key: "Lubrication",
      open: () => {
        console.log("setIsOpenLubrication",isOpenLubrication );
        setIsOpenLubrication(!isOpenLubrication)
      },
      close: () => {
        console.log("setIsOpenWearable",isOpenWearable );
        setIsOpenLubrication(!isOpenLubrication)
      },
      isOpen: isOpenLubrication,
    }
  ]
const [selectedType, setSelectedType] = useState({})
const HandleClickAdd = (elem) => () => {
  setOpenAddExpanse(true)
  setSelectedType(elem)
}
    const renderServices = (data) => {
        console.log(data,"renderServicesrenderServices");
        const serviceData = Object.keys(data).map(elem => {
          return {
            key: elem,
            value: data[elem],
            expenseType: elem
          }
        })
        return (
          <div>
            {serviceData.map((elem) => {
                      console.log(elem, "itemDataelemelemelem");
                      return ( 
                            <ProfileItems 
                                type={elem.key}
                                expenseType={elem.expenseType}
                                value={elem.value}
                                fleetId={fleetId}
                                vehicle={vehicle}
                            />
                            // <div>ajhskcab ajhsbd {elem.value}</div>
                          )
                    })}
          </div>
        )
    }
    return (
        <div>
            {serviceList.map((elem) => {
                return (
                    <div>
                        <Collapsible
                        trigger={
                            <div style={{
                              display: "flex",
                              flexDirection: "row",}}>
                            <div
                              className="ServiceList col-11"
                              style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "40px",
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                              }}
                            >
                            <p5>{elem.key}</p5>
                            </div>
                              <div className="ServiceList col-1" 
                              style={{display: "flex",flexDirection: "row", paddingTop:"5px"}}
                              onClick={HandleClickAdd(elem)}>
                                <div><IoIosAddCircle size={20} color="#4D5073" /> </div>
                                <div style={{ margin:"2px"}}>Add</div>
                              </div>
                            </div>

                        }
                        // triggerSibling="hskdg shkdg"
                        open={elem.key == "Wearables" ? true : false}
                        onOpening={() => elem.open()}
                        onClosing={()=> elem.close()}
                        >
                        <div style={{ margin: "10px" }}>
                            {elem.isOpen ? renderServices(serviceItems[elem.key]) : <></>}
                        </div>
                        </Collapsible>
                    </div>
                );
            })}
            {
              openAddExpanse ? (<AddItemTypeModal
                toggle={toggleAddExpense}
                modal={openAddExpanse}
                setModal={setOpenAddExpanse}
                data={selectedType}
              />):<></>
            }
        </div>

    )
}
export default ServiceAndMaintainance;
